import { useEffect } from 'react';

function PaidMediaPixels() {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.document) {
      // Google Ads Conversion Tracking
      const googleAdsScript = document.createElement('script');
      googleAdsScript.innerHTML = `
        function gtag_report_conversion(url) {
          var callback = function () {
            if (typeof(url) != 'undefined') {
              window.location = url;
            }
          };
          gtag('event', 'conversion', {
              'send_to': 'AW-821881030/uugpCIWzg9EBEMbR84cD',
              'event_callback': callback
          });
          return false;
        }
      `;
      document.head.appendChild(googleAdsScript);

      // Meta (Facebook) Pixel Tracking
      const metaPixelScript = document.createElement('script');
      metaPixelScript.innerHTML = `
        fbq('trackCustom', 'click_signup', { });
      `;
      document.head.appendChild(metaPixelScript);

      // Reddit Pixel Tracking
      const redditPixelScript = document.createElement('script');
      redditPixelScript.innerHTML = `
        rdt('track', 'SignUp');
      `;
      document.head.appendChild(redditPixelScript);

      // Microsoft Ads (Bing UET) Tracking
      const microsoftPixelScript = document.createElement('script');
      microsoftPixelScript.innerHTML = `
        window.uetq = window.uetq || [];
        window.uetq.push('event', 'click_signup', {});
      `;
      document.head.appendChild(microsoftPixelScript);
    }
  }, []);

  return null;
}

export default PaidMediaPixels;
